import { PipeTransform, Pipe } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ThemeService } from '@services/tenant/theme.service';
import { firstValueFrom } from 'rxjs';


@Pipe({ name: 'imgConfiguration' })
export class ImgConfigurationPipe implements PipeTransform {
  private emptyTransparentGif = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

  constructor(public themeService: ThemeService, private _sanitizer: DomSanitizer) {
  }

  async transform(value: string, defaultValue?: string): Promise<SafeResourceUrl> {
    const imgConfigurationMap = await firstValueFrom(this.themeService.imgConfigurationMap$);
    const conf = imgConfigurationMap.find((imgConfiguration: any) => imgConfiguration.name === value);
    return this._sanitizer.bypassSecurityTrustUrl(conf?.base64 ? conf.base64 : (defaultValue ? defaultValue : this.emptyTransparentGif));
  }
  
}
